//React
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
//API
import { HomeApi } from "../../api";
//Components
import Header from "../../components/Header/Header";
import PatientList from "../../components/PatientList/PatientList";
import Footer from "../../components/Footer/Footer";
//assets
import TodayScreeningIcon from "../../assets/images/PatientLogo.svg";
import TodayScreeningWarningIcon from "../../assets/images/PatientLogoWarning.svg";
import TodayScreeningAbnormalIcon from "../../assets/images/PatientLogoAbnormal.svg";
import ChartIcon from "../../assets/images/Chart.svg";
import CheckCircleIcon from "../../assets/images/CheckCircle.svg";
import WarningCircleIcon from "../../assets/images/WarningCircle.svg";
import AbnormalCircleIcon from "../../assets/images/AbnormalCircle.svg";
//CSS
import "./Home.css";
//LocalStorage
import SecureStorage from "react-secure-storage";

const initialBoxData = [
  {
    title: "Today Screening",
    style: "normal",
    icon: TodayScreeningIcon,
    number: 1,
    unit: "명",
  },
  {
    title: "정상 소견",
    style: "green",
    icon: TodayScreeningIcon,
    number: 1,
    unit: "명",
  },
  {
    title: "주의 소견",
    style: "warning",
    icon: TodayScreeningWarningIcon,
    number: 1,
    unit: "명",
  },
  {
    title: "이상 소견",
    style: "abnormal",
    icon: TodayScreeningAbnormalIcon,
    number: 1,
    unit: "명",
  },
];

const Home = () => {
  const navigate = useNavigate();
  const [userName, setUserName] = useState(SecureStorage.getItem("userName"));
  const [todayDate, setTodayDate] = useState(new Date());
  const [boxData, setBoxData] = useState(initialBoxData);
  useEffect(() => {
    cleanPatientCode();
    setTodayDate(new Date());
  }, []);

  useEffect(() => {
    const getHome = async () => {
      const response = await HomeApi.getHome(SecureStorage.getItem("doctorId"));
      console.log("response ->", response);
      if (response && !response.error) {
        // API 응답 데이터로 boxData 업데이트
        setBoxData([
          {
            title: "Today Screening",
            style: "normal",
            icon: TodayScreeningIcon,
            number: response.todayPatientCount || 0,
            unit: "명",
          },
          {
            title: "정상 소견",
            style: "green",
            icon: TodayScreeningIcon,
            number: response.todayDiagnosisGreenCount || 0,
            unit: "명",
          },
          {
            title: "주의 소견",
            style: "warning",
            icon: TodayScreeningWarningIcon,
            number: response.todayDiagnosisYellowCount || 0,
            unit: "명",
          },
          {
            title: "이상 소견",
            style: "abnormal",
            icon: TodayScreeningAbnormalIcon,
            number: response.todayDiagnosisRedCount || 0,
            unit: "명",
          },
        ]);
      }
    };
    getHome();
  }, []);

  const cleanPatientCode = () => {
    if (SecureStorage.getItem("createdPatientCode")) {
      SecureStorage.removeItem("createdPatientCode");
    }
  };

  const formatDateWithWeekday = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const weekdays = ["일", "월", "화", "수", "목", "금", "토"];
    const weekday = weekdays[date.getDay()];
    return `${year}년 ${month}월 ${day}일 ${weekday}요일`;
  };

  const totalCount = boxData
    .filter((item) => item.title !== "Today Screening")
    .reduce((sum, item) => sum + item.number, 0);
  const chartData = [
    {
      label: "정상",
      count: boxData[1]?.number || 0, // 정상 소견
      percentage:
        totalCount > 0
          ? Math.round((boxData[1]?.number / totalCount) * 100)
          : 0,
      color: "#16A34A",
      icon: CheckCircleIcon,
    },
    {
      label: "주의",
      count: boxData[2]?.number || 0, // 주의 소견
      percentage:
        totalCount > 0
          ? Math.round((boxData[2]?.number / totalCount) * 100)
          : 0,
      color: "#FFA000",
      icon: WarningCircleIcon,
    },
    {
      label: "이상",
      count: boxData[3]?.number || 0, // 이상 소견
      percentage:
        totalCount > 0
          ? Math.round((boxData[3]?.number / totalCount) * 100)
          : 0,
      color: "#FF0000",
      icon: AbnormalCircleIcon,
    },
  ];

  const onPatientCreated = (createdPatientCode) => {
    navigate(`/main`, { state: { createdPatientCode } });
  };

  return (
    <div className="home">
      <Header />
      <div className="home-main-container">
        <PatientList onPatientCreated={onPatientCreated} />
        <div className="home-main-container-content">
          <div className="home-container-header">
            <div className="home-container-header-title">
              {`안녕하세요, ${userName} 원장님.`}
            </div>
            <div className="home-container-header-sub-title">
              <div>오늘의 Rotator Cuff Screening 현황입니다.</div>
              <div>{formatDateWithWeekday(todayDate)}</div>
            </div>
          </div>
          <div className="box-container-wrapper">
            {boxData
              .filter((item) => item.title !== "정상 소견")
              .map((item, index) => {
                const Icon = item.icon;
                return (
                  <div key={index} className="box-container">
                    <div
                      className={`box-container-header ${
                        item.style || ""
                      }`.trim()}
                    >
                      <div>{item.title}</div>
                      <Icon />
                    </div>
                    <div className="box-container-number-container">
                      <div className="box-container-number">{item.number}</div>
                      <div className="box-container-number-unit">
                        {item.unit}
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
          <div className="screening-result-chart-container">
            <div className="screening-result-chart-header">
              <ChartIcon />
              <div>금일 스크리닝 결과 분포</div>
            </div>
            <div className="screening-result-chart-list">
              {chartData.map((item, index) => {
                const Icon = item.icon;
                return (
                  <div key={index} className="screening-result-chart-item">
                    <div className="screening-result-chart-item-content">
                      <Icon width={20} height={20} />
                      <div className="screening-result-chart-item-label">
                        {item.label}
                      </div>
                      <div className="screening-result-chart-item-count">
                        {item.count}건 ({item.percentage}%)
                      </div>
                    </div>
                    <div className="screening-result-chart-progress-bar">
                      <div
                        className="screening-result-chart-progress-fill"
                        style={{
                          width: `${item.percentage}%`,
                          backgroundColor: item.color,
                        }}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Home;
